<template>
  <div class="stern-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$μ_z = ± (eħ / 2m)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage" @mousedown="isFiring = true" @mouseup="isFiring = false">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>磁场梯度 dB/dz</label>
            <span class="val">{{ gradient.toFixed(2) }} T/m</span>
          </div>
          <div class="hud-item rose">
             <label>探测屏状态</label>
             <span class="val">{{ hitCount }} 粒子已命中</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 500 240" preserveAspectRatio="xMidYMid meet">
          <!-- 银原子源 -->
          <rect x="20" y="100" width="40" height="40" fill="#64748b" />
          <text x="40" y="155" text-anchor="middle" fill="#94a3b8" font-size="10">银原子炉</text>

          <!-- 非均匀磁场 (磁极形状) -->
          <path d="M 120,60 L 220,60 L 220,100 L 120,80 Z" fill="#334155" stroke="#475569" />
          <path d="M 120,180 L 220,180 L 220,140 L 120,160 Z" fill="#334155" stroke="#475569" />
          <text x="170" y="50" text-anchor="middle" fill="#94a3b8" font-size="10">非均匀磁场 N/S</text>

          <!-- 原子流轨迹 (实时分裂) -->
          <g v-for="p in particles" :key="p.id">
             <circle :cx="p.x" :cy="p.y" r="2.5" :fill="p.spin > 0 ? '#f43f5e' : '#3b82f6'" opacity="0.8" />
          </g>

          <!-- 探测屏 -->
          <rect x="420" y="40" width="5" height="160" fill="#1e293b" />
          <!-- 命中点堆积 (模拟密度函数) -->
          <g v-for="h in hits" :key="'h'+h.id">
             <rect x="425" :y="h.y - 1" width="15" height="2" :fill="h.spin > 0 ? '#f43f5e' : '#3b82f6'" opacity="0.4" />
          </g>
        </svg>

        <div class="physics-caption">
          <strong>物理规律：</strong>在经典物理预言中，原子的磁矩在空间中应连续分布，因此命中屏应成连续条状。但实验观察到其分裂为<strong>上下离散的两束</strong>，无可辩驳地证明了自旋量子化的存在。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row"><span class="label">调节磁场梯度强度</span></div>
           <el-slider v-model="gradient" :min="0" :max="5.0" :step="0.1" size="small"></el-slider>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-aim"></i>
           <p><strong>实战物理：</strong>这也是现代核磁共振(MRI)和自旋电子学的理论基石。<strong>观察：</strong>点击屏幕发射原子。当磁场梯度为零时，原子不偏转；当梯度增大且磁场开启，你会发现原子“非上即下”，绝对不会落在中间。这展示了<strong>本征态的离散性</strong>。
           </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'SternGerlachViz',
  data() {
    return {
      gradient: 2.5,
      isFiring: false,
      particles: [],
      hits: [],
      hitCount: 0,
      timer: 0
    }
  },
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
       requestAnimationFrame(this.animate);
       this.timer++;
       
       // 每隔几帧发射粒子
       if (this.isFiring && this.timer % 3 === 0) {
          this.particles.push({
             id: Date.now() + Math.random(),
             x: 60,
             y: 120,
             vx: 4,
             spin: Math.random() > 0.5 ? 1 : -1
          });
       }

       // 更新粒子路径
       this.particles.forEach((p, idx) => {
          p.x += p.vx;
          // 在磁场区域偏转: 120 < x < 220
          if (p.x > 120 && p.x < 220) {
             p.y += (p.spin * this.gradient) * 0.15;
          }
          // 在磁场后继续惯性运动
          if (p.x >= 220) {
             p.y += (p.spin * this.gradient) * 0.08;
          }
          
          // 判定命中
          if (p.x >= 420) {
             this.hits.push({ id: p.id, y: p.y, spin: p.spin });
             if (this.hits.length > 100) this.hits.shift();
             this.hitCount++;
             this.particles.splice(idx, 1);
          }
       });
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.stern-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
